/**
 * Shared helpers for Coring Activity and Coring Data Explorer.
 * Keeps hole matching and API date params consistent across tabs.
 */

/** Normalize hole ID/name for comparison - handles 26SCM156B vs SCM26156B format mismatch */
export function normalizeHoleForCompare(id) {
  if (!id) return '';
  const s = String(id).toUpperCase().replace(/\s/g, '');
  const m = s.match(/^(\d{2})(SCM)(.*)$/);
  if (m) return m[2] + m[1] + m[3];
  return s;
}

/**
 * Build { start_date, end_date } or {} for all-time — same logic as former CoringActivity getDateRange.
 * @param {string} dateRange - 'week' | 'month' | 'year' | 'all' | 'custom'
 */
export function computeCoringDateParams(dateRange, customStartDate, customEndDate) {
  if (dateRange === 'all') {
    return {};
  }

  const today = new Date();
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  let startDate = new Date(today);

  switch (dateRange) {
    case 'week':
      startDate.setDate(today.getDate() - 7);
      break;
    case 'month':
      startDate.setMonth(today.getMonth() - 1);
      break;
    case 'year':
      startDate.setFullYear(today.getFullYear() - 1);
      break;
    case 'custom':
      if (customStartDate && customEndDate) {
        return {
          start_date: customStartDate,
          end_date: customEndDate
        };
      }
      startDate.setMonth(today.getMonth() - 1);
      break;
    default:
      startDate.setMonth(today.getMonth() - 1);
  }

  return {
    start_date: formatDate(startDate),
    end_date: formatDate(today)
  };
}

/** Whether a coring row passes hole filter + optional search (same rules as CoringActivity filteredData). */
export function rowPassesVizFilters(row, holeFilters, searchTerm) {
  const normalizedFilters = holeFilters?.length
    ? new Set(holeFilters.map(normalizeHoleForCompare))
    : null;

  if (normalizedFilters && normalizedFilters.size > 0) {
    const normalizedRowHole = normalizeHoleForCompare(row.hole_name);
    if (!normalizedFilters.has(normalizedRowHole)) {
      return false;
    }
  }

  if (searchTerm) {
    const holeName = row.hole_name?.toLowerCase() || '';
    const search = searchTerm.toLowerCase();
    const cleanHoleName = holeName.replace(/^\d{2}scm0*/i, '');
    if (!holeName.includes(search) && !cleanHoleName.includes(search)) {
      return false;
    }
  }

  return true;
}
